import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const ValidateCnh = (cnh, setIsValid) => {
    if (!cnh) {
        setIsValid(true);
        return;
    }

    axios.post(`${API_URL}/validator/cnh`, {cnh})
        .then(() => setIsValid(true))
        .catch(() => setIsValid(false));
};

export default ValidateCnh;